import { render, staticRenderFns } from "./MediaConfig.vue?vue&type=template&id=325814dc&scoped=true"
import script from "./MediaConfig.vue?vue&type=script&lang=js"
export * from "./MediaConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325814dc",
  null
  
)

export default component.exports